import _ from 'lodash';
import moment from 'moment';
import CashflowViewApi from '../../api/CashflowViewApi';

const MONTHS_BACK = 5;

async function getBudget(budgetDate) {
  return CashflowViewApi.fetchBudget({ budgetDate });
}

async function getBudgets(budgetDates) {
  const customerBudgets = await CashflowViewApi.fetchAllBudgets();
  return _.chain(customerBudgets)
    .filter(budget => _.includes(budgetDates, budget.budgetDate))
    .sortBy(budget => budget.budgetDate)
    .reverse()
    .value();
}

function getPresentedBudgetDates() {
  const currentBudgetDate = getCurrentBudgetDate();
  return _extendFiveMonthsBack(currentBudgetDate);
}

function _extendFiveMonthsBack(openMonthBudgetDate) {
  const openBudgetDate = moment(openMonthBudgetDate);
  const presentedBudgetDates = [openMonthBudgetDate];
  for (let i = 1; i <= MONTHS_BACK; i++) {
    presentedBudgetDates.push(openBudgetDate.clone().subtract(i, 'month').format('YYYY-MM'));
  }
  return _.filter(presentedBudgetDates);
}

function getCurrentBudgetDate() {
  return moment().format('YYYY-MM');
}

function getPrevBudgetDate(budgetDate) {
  return moment(budgetDate).subtract(1, 'month').format('YYYY-MM');
}

function getNextBudgetDate(budgetDate) {
  return moment(budgetDate).add(1, 'month').format('YYYY-MM');
}

function getMonthName(budgetDate) {
  return moment(budgetDate).locale('he').format('MMM');
}

function getFullMonthName(budgetDate) {
  return moment(budgetDate).locale('he').format('MMMM');
}

export default {
  getPresentedBudgetDates,
  getBudget,
  getBudgets,
  getCurrentBudgetDate,
  getPrevBudgetDate,
  getNextBudgetDate,
  getMonthName,
  getFullMonthName,
};
